import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import {
  ArrowLeft,
  ChevronDown,
  ChevronUp,
  Info
} from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import { setToogleHeader } from "../../core/redux/action";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Swal from "sweetalert2";
import { api_post } from "../../helpers/index";
import Select from "react-select";

const AddUser = () => {
  const route = all_routes;
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const navigate = useNavigate(); // Initialize navigate hook

  // State for user details
  const [userName, setUserName] = useState("");
  const [name, setName] = useState("");
  const [permission, setPermission] = useState(null);
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  // Validate input fields
  const validateInputs = () => {
    const newErrors = {};
    if (!userName.trim()) newErrors.userName = "Username is required.";
    if (!name.trim()) newErrors.name = "Name is required.";
    if (!password.trim()) newErrors.password = "Password is required.";
    if (!permission) newErrors.permission = "Permission is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle saving the user
  const handleSaveUser = async () => {
    if (!validateInputs()) {
      return;
    }

    const body = {
      user_name: userName,
      name: name,
      password: password,
      permission: permission?.value,
    };
    try {
      const result = await api_post("user/create", body);
      if (result.status === 1) {
        // Show success message with SweetAlert2 and navigate to user list
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "User created successfully!",
        }).then(() => {
          navigate(route.userlist);
        });
      } else {
        // Show error message with SweetAlert2
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to create user. Please try again later.",
        });
      }
    } catch (error) {
      console.error("Error creating user:", error);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>New User</h4>
              <h6>Create new user</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <div className="page-btn">
                <Link to={route.userlist} className="btn btn-secondary">
                  <ArrowLeft className="me-2" />
                  Back to User List
                </Link>
              </div>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Collapse"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => {
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp className="feather-chevron-up" />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>
        <form>
          <div className="card">
            <div className="card-body add-prize pb-0">
              <div
                className="accordion-card-one accordion"
                id="accordionExample"
              >
                <div className="accordion-item">
                  <div className="accordion-header" id="headingOne">
                    <div
                      className="accordion-button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-controls="collapseOne"
                    >
                      <div className="addprize-icon">
                        <h5>
                          <Info className="add-info" />
                          <span>User Information</span>
                        </h5>
                        <Link to="#">
                          <ChevronDown className="chevron-down-add" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div className="row">
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-prize">
                            <label className="form-label">Username</label>
                            <input
                              type="text"
                              className="form-control"
                              value={userName}
                              onChange={(e) => setUserName(e.target.value)}
                            />
                            {errors.userName && (
                              <div className="text-danger mt-1">
                                {errors.userName}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-prize">
                            <label className="form-label">Password</label>
                            <input
                              type="password"
                              className="form-control"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                            />
                            {errors.password && (
                              <div className="text-danger mt-1">
                                {errors.password}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-prize">
                            <label className="form-label">Name</label>
                            <input
                              type="text"
                              className="form-control"
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                            />
                            {errors.name && (
                              <div className="text-danger mt-1">
                                {errors.name}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-prize">
                            <label className="form-label">Permission</label>
                            <Select
                              classNamePrefix="react-select"
                              options={[{ value: "admin", label: "Admin" }]}
                              placeholder="Choose"
                              value={permission}
                              onChange={(selectedOption) =>
                                setPermission(selectedOption)
                              }
                            />
                            {errors.permission && (
                              <div className="text-danger mt-1">
                                {errors.permission}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="btn-addprize mb-4">
              <button
                type="button"
                className="btn btn-cancel me-2"
                onClick={() => {
                  navigate(route.userList);
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-submit"
                onClick={handleSaveUser}
              >
                Save User
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUser;
